/**
 * PURPOSE: Evaluates WorkflowStatus on specific trigger actions and emits the resulting
 * navigation intent. Re-evaluates state AFTER next(action) and dispatches SET_WORKFLOW_STATUS.
 * Does NOT know about routes — that is navigationMiddleware's concern.
 */
import { evaluate, setWorkflowStatus, Actions } from '@makemydeal/dr-sales-checkin-store';
import { FETCH_DEAL_SUMMARY_PDF_SUCCESS } from '@makemydeal/activities-request-proposal';
import type { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { bootstrapActionTypes, initActionTypes } from '@makemydeal/dr-shared-store';

// Only these actions trigger workflow re-evaluation.
// All other actions update state but won't cause implicit navigation.
// Explicit navigation uses NAVIGATE_TO via navigationMiddleware.
const triggerActionTypes = new Set([
    initActionTypes.INIT_PENCIL_SUCCESS, // bootstrap resolved — server seeded status
    bootstrapActionTypes.BOOTSTRAP_FAILURE, // bootstrap failed — show error page
    // TODO: Below actions should exists in shared location
    Actions.UPDATE_DEAL_SUCCESS, // deal saved — re-evaluate workflow
    Actions.FETCH_DEAL_SUCCESS, // GTL deal refresh — re-evaluate workflow, same as init/deal save
    Actions.UPDATE_ACTIVE_DEAL_FROM_PARTICIPANTS_SAVE, // customer details saved — re-evaluate workflow, same as deal save
    FETCH_DEAL_SUMMARY_PDF_SUCCESS
]);

export const workflowEvaluatorMiddleware = (store: any) => (next: any) => (action: any) => {
    // Read before reducers run, so at bootstrap this is still the initial IDLE.

    next(action); // always propagate — reducers and downstream middleware run here

    if (!triggerActionTypes.has(action.type)) {
        return;
    }

    const nextStatus: WorkflowStatus = evaluate(store.getState());

    store.dispatch(setWorkflowStatus(nextStatus));
};
